import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AppService } from '@cigna/cigna-for-brokers/shared/data-access';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cigna-cafooter-unsecure',
  templateUrl: './footer-unsecure.component.html',
  styleUrls: ['./footer-unsecure.component.scss'],
})
export class FooterUnSecureComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  currentYear = new Date().getFullYear().toString();
  footer: Record<string, unknown>;
  isIntegrationOn = false;
  isIntegrationFooterVisible = false;

  @ViewChild('integrationFooter')
  private integrationFooterRef?: ElementRef<HTMLElement>;

  private integrationFooterObserver?: IntersectionObserver;
  private _ngUnsubscribe$ = new Subject<void>();

  constructor(
    private translate: TranslateService,
    private _appService: AppService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.footer = this.translate.instant('footer') as Record<string, unknown>;

    this._appService.isIntegrationOn$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isIntegrationOn) => {
        this.isIntegrationOn = isIntegrationOn;

        if (isIntegrationOn) {
          this.scheduleIntegrationFooterObserverSetup();
          return;
        }

        this.teardownIntegrationFooterObserver();
        this.isIntegrationFooterVisible = false;
      });
  }

  ngAfterViewInit(): void {
    this.scheduleIntegrationFooterObserverSetup();
  }

  ngOnDestroy(): void {
    this.teardownIntegrationFooterObserver();
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }

  private scheduleIntegrationFooterObserverSetup(): void {
    if (!this.isIntegrationOn) {
      return;
    }

    setTimeout(() => this.setupIntegrationFooterObserver());
  }

  private setupIntegrationFooterObserver(): void {
    const footerElement = this.integrationFooterRef?.nativeElement;

    if (!this.isIntegrationOn || !footerElement) {
      return;
    }

    this.teardownIntegrationFooterObserver();

    this.integrationFooterObserver = new IntersectionObserver(
      ([entry]) => {
        this.isIntegrationFooterVisible = entry.isIntersecting;
        this._changeDetectorRef.markForCheck();
      },
      { threshold: 0.01 },
    );

    this.integrationFooterObserver.observe(footerElement);
  }

  private teardownIntegrationFooterObserver(): void {
    this.integrationFooterObserver?.disconnect();
    this.integrationFooterObserver = undefined;
  }
}
